// extracted by mini-css-extract-plugin
module.exports = {"sizeXs":".25em","sizeSm":".5em","sizeMd":"1em","sizeLg":"1.5em","sizeXl":"2em","button":"button_button__1aRKK","buttonLink":"button_buttonLink__1-Fe6"};